import '@fshr/shared-react/rum';
